module.exports = __webpack_public_path__ + "img/Karagandy_obl.c7ecc987.png";